<template>
  <div class="popular">
    <div class="container">
      <div class="popular__wrapper">
        <div class="popular__top">
          <div class="popular__top-inner">
            <p>{{ t('home.popular.text') }}</p>
            <h2>{{ t('home.popular.title') }}</h2>
          </div>
          <div class="popular__buttons">
            <svg ref="prevButton" width="83" height="83" viewBox="0 0 83 83" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <g filter="url(#filter0_f_2191_1312)">
                <circle cx="41.4971" cy="41.5005" r="31" stroke="#FF0000" stroke-width="3"/>
              </g>
              <circle cx="41.4971" cy="41.5005" r="32" stroke="#FF0000"/>
              <path d="M61.9971 43.5C62.8255 43.5 63.4971 42.8284 63.4971 42C63.4971 41.1716 62.8255 40.5 61.9971 40.5L61.9971 43.5ZM20.9364 40.9393C20.3506 41.5251 20.3506 42.4749 20.9364 43.0607L30.4824 52.6066C31.0681 53.1924 32.0179 53.1924 32.6037 52.6066C33.1895 52.0208 33.1895 51.0711 32.6037 50.4853L24.1184 42L32.6037 33.5147C33.1895 32.9289 33.1895 31.9792 32.6037 31.3934C32.0179 30.8076 31.0681 30.8076 30.4824 31.3934L20.9364 40.9393ZM61.9971 42L61.9971 40.5L21.9971 40.5L21.9971 42L21.9971 43.5L61.9971 43.5L61.9971 42Z"
                    fill="#F3F3F3"/>
              <defs>
                <filter id="filter0_f_2191_1312" x="0.797071" y="0.800488" width="81.4" height="81.4"
                        filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                  <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                  <feGaussianBlur stdDeviation="4.1" result="effect1_foregroundBlur_2191_1312"/>
                </filter>
              </defs>
            </svg>
            <svg ref="nextButton" width="83" height="83" viewBox="0 0 83 83" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <g filter="url(#filter0_f_2191_1312)">
                <circle cx="41.4971" cy="41.5005" r="31" stroke="#FF0000" stroke-width="3"/>
              </g>
              <circle cx="41.4971" cy="41.5005" r="32" stroke="#FF0000"/>
              <path d="M61.9971 43.5C62.8255 43.5 63.4971 42.8284 63.4971 42C63.4971 41.1716 62.8255 40.5 61.9971 40.5L61.9971 43.5ZM20.9364 40.9393C20.3506 41.5251 20.3506 42.4749 20.9364 43.0607L30.4824 52.6066C31.0681 53.1924 32.0179 53.1924 32.6037 52.6066C33.1895 52.0208 33.1895 51.0711 32.6037 50.4853L24.1184 42L32.6037 33.5147C33.1895 32.9289 33.1895 31.9792 32.6037 31.3934C32.0179 30.8076 31.0681 30.8076 30.4824 31.3934L20.9364 40.9393ZM61.9971 42L61.9971 40.5L21.9971 40.5L21.9971 42L21.9971 43.5L61.9971 43.5L61.9971 42Z"
                    fill="#F3F3F3"/>
              <defs>
                <filter id="filter0_f_2191_1312" x="0.797071" y="0.800488" width="81.4" height="81.4"
                        filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                  <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                  <feGaussianBlur stdDeviation="4.1" result="effect1_foregroundBlur_2191_1312"/>
                </filter>
              </defs>
            </svg>
          </div>
        </div>
        <swiper
          class="swiper"
          :modules="[Navigation]"
          :navigation="{ prevEl: prevButton, nextEl: nextButton }"
          :speed="500"
          :spaceBetween="40"
          :breakpoints="{
            100: {
              slidesPerView: 1
            },
            650: {
              slidesPerView: 2
            },
            1000: {
              slidesPerView: 3
            },
            1300: {
              slidesPerView: 4
            }
          }"
        >
          <swiper-slide
              class="swiper__slide"
              v-for="product in products"
              :key="product.node.uuid"
          >
            <product-card
                :product="product.node"
            />
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css/pagination';
import 'swiper/css';
import {Navigation} from "swiper/modules";
import {onMounted, ref} from "vue";
import ProductCard from "@/components/cards/product-card.vue";
import {Products} from "@/core/api/products.js";
import {useI18n} from "vue-i18n";

const {t} = useI18n()

const prevButton = ref(null);
const nextButton = ref(null);

const products = ref([])

onMounted( async () => {
  const res = await Products.getProducts(`tags: "top"`)
  products.value = res.data.products.edges.slice(0, 6)
})
</script>

<style lang="scss" scoped>
.popular {
  border-top: 2px solid $white;
  background-image: url(@images/popularBg.png);
  background-repeat: no-repeat;
  background-size: cover;
  padding-block: 75px;

  &__wrapper {
    display: flex;
    flex-direction: column;
    gap: 50px;
  }

  &__top {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;

    &-inner {
      & p {
        color: #F3F3F3;
        font-size: 20px;
      }

      & h2 {
        color: #F3F3F3;
        font-size: 64px;
        font-weight: 700;
      }
    }
  }

  &__buttons {
    display: flex;
    align-items: center;
    gap: 20px;

    & svg {
      cursor: pointer;
      transition: 0.2s;

      &:last-child {
        transform: rotate(180deg);
      }

      @include hover {
        color: #ff0000;
      }
    }
  }
}

.swiper {
  width: 100%;
  padding: 20px;

  &__slide {
    display: grid;
    place-items: center;
  }
}

:deep(.swiper-button-disabled) {
  opacity: 0.5;
  cursor: not-allowed !important;

  @include hover {
    color: #000 !important;
  }
}

@media (max-width: 1100px) {
  .popular {
    &__top {
      &-inner {
        & p {
          font-size: 16px;
        }

        & h2 {
          font-size: 36px;
        }
      }
    }
  }
}

@media (max-width: 700px) {
  .popular {
    &__top {
      flex-direction: column;
      align-items: flex-start;
      gap: 50px;
    }
  }
}
</style>